import { createAction, props } from '@ngrx/store';

const hydratePackageItems = createAction('[Load Package Items]', props<{ data: any }>());

const packageItemUpdated = createAction(
  '[Update Package Item]',
  props<{ itemId: string; packageQuantity: string; notPackageRows: any[] }>(),
);

export { hydratePackageItems, packageItemUpdated };
